import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import MainLayout from "@/components/MainLayout";
import LoginPage from "@/components/LoginPage";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  const [auth, setAuth] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      setIsLoading(false);
      return;
    }
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    axios
      .get(`${API_URL}/auth/me`)
      .then((response) => {
        setAuth({ token, ...response.data });
      })
      .catch(() => {
        localStorage.removeItem("auth_token");
        setAuth(null);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const handleLogin = ({ token, role, username }) => {
    localStorage.setItem("auth_token", token);
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    setAuth({ token, role, username });
  };

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    delete axios.defaults.headers.common.Authorization;
    setAuth(null);
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        {isLoading ? null : auth ? (
          <Routes>
            <Route
              path="/*"
              element={<MainLayout user={auth} onLogout={handleLogout} />}
            />
          </Routes>
        ) : (
          <LoginPage onLogin={handleLogin} />
        )}
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
